export const WORDBANK = 'WORDBANK';
export const QUESTION_NONE = 'QUESTION_NONE';
export const OPTION_NONE = 'OPTION_NONE';
export const EXPLANATION_NONE = 'EXPLANATION_NONE';
export const CHALLENGE_QUESTION = 'CHALLENGE_QUESTION';
export const CHALLENGE_OPTION = 'CHALLENGE_OPTION';
export const CHALLENGE_EXPLANATION = 'CHALLENGE_EXPLANATION';
export const ACTIVITY_QUESTION = 'ACTIVITY_QUESTION';
